import opacify from "../../../../services/opacify";
import Kpi from "../../../Tools/Kpi";
import Flex from '../../../Tools/Flex';

export default function Kpis({enrollments, person}){


    const count = enrollments.length;

    const revenue = enrollments
        .map(e => e.amount)
        .reduce((a,b) => a + b, 0);

    const completion = !count ? 0 : Math.round(
        enrollments
            .map(e => e.completion)
            .reduce((a,b) => a + b, 0)
        / count);

    
    const color = o => opacify(person.category?.color || 'white', o);

    const sx = {mr: 1, mb: 1}

    return <Flex>

            <Kpi 
                title={count.toLocaleString()} 
                caption="Inscriptions"
                color={color(1)}
                icon='school'
                sx={sx}
            />

            <Kpi 
                title={revenue.toLocaleString() + ' €'} 
                caption="Chiffre d'affaire"
                color={color(1)}
                icon='progress'
                sx={sx}
            />
            
            <Kpi 
                title={completion.toLocaleString() + ' %'} 
                caption="Complétion"
                color={color(1)}
                icon='check'
                sx={sx}
            />

        </Flex>

}